"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale integrations Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.POFileStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.POFileStatus = {
    PERSISTED: 'persisted',
    DOWNLOADED: 'downloaded',
    UPLOADED: 'uploaded',
    IMPORTED: 'imported',
    ORDER_CREATED: 'order_created',
    SUBMITTED: 'submitted',
    FAILED: 'failed',
    SKIPPED: 'skipped',
    CANCELLED: 'cancelled',
    ASN_SENT: 'asn_sent',
    ASN_FAILED: 'asn_failed',
    ASN_CREATED: 'asn_created',
    REJECTED: 'rejected',
    MISSING_RELATION_ID: 'missing_relation_id',
    OUT_OF_STOCK: 'out_of_stock'
};
//# sourceMappingURL=pofile-status.js.map